import { WorkoutModel } from '../../BusinessLogic/Models/WorkoutModel';
import { BreakdownModel } from '../../BusinessLogic/Models/BreakdownModel';
import { ClassBookerModel } from '../../BusinessLogic/Models/ClassBookerModel';
import { ClassMemberModel } from '../../BusinessLogic/Models/ClassMemberModel';
import { ClassModel } from '../../BusinessLogic/Models/ClassModel';
import { LeaderboardModel } from '../../BusinessLogic/Models/LeaderboardModel';
import { MembershipPlanModel } from '../../BusinessLogic/Models/MembershipPlanModel';
import { WaitingMemberModel } from '../../BusinessLogic/Models/WaitingMemberModel';
import { UserBirthdayModel } from '../../BusinessLogic/Models/UserBirthdayModel';
import { MemberModel } from '../../BusinessLogic/Models/MemberModel';
import { UserModel } from '../../BusinessLogic/Models/UserModel';
import { DayWeekWorkoutModel } from '../../BusinessLogic/Models/DayWeekWorkoutModel';

export const getUserModelsArray = users =>
    users.map(user => {
        const userModel = new UserModel(user);
        return { ...userModel.user };
    });

export const getWorkoutModelsArray = workouts =>
    workouts.map(workout => {
        const workoutModel = new WorkoutModel(workout);
        return { ...workoutModel.workout };
    });

export const getBreakdownModelsArray = breakdowns =>
    breakdowns.map(breakdown => {
        const breakdownModel = new BreakdownModel(breakdown);
        return { ...breakdownModel.breakdown };
    });

export const getClassModelsArray = classes =>
    classes.map(_class => {
        const classModel = new ClassModel(_class);
        return { ...classModel.__class };
    });

export const getClassMemberModelsArray = members =>
    members.map(member => {
        const classMemberModel = new ClassMemberModel(member);
        return { ...classMemberModel.member };
    });

export const getClassBookerModelsArray = bookers =>
    bookers.map(booker => {
        const classBookerModel = new ClassBookerModel(booker);
        return { ...classBookerModel.booker };
    });

export const getLeaderboardModelsArray = leaderboards =>
    leaderboards.map(leaderboard => {
        const leaderboardModel = new LeaderboardModel(leaderboard);
        return { ...leaderboardModel.leaderboard };
    });

export const getMembershipPlanModelsArray = membershipPlans =>
    membershipPlans.map(membershipPlan => {
        const membershipPlanModel = new MembershipPlanModel(membershipPlan);
        return { ...membershipPlanModel.membershipPlan };
    });

export const getMemberModelsArray = members => {
    return members.map(member => {
        const memberModel = new MemberModel(member);
        return { ...memberModel.member };
    });
};

export const getUserBirthdayModelsArray = birthdays =>
    birthdays.map(bday => {
        const userBirthdayModel = new UserBirthdayModel(bday);
        return { ...userBirthdayModel.userBirthday };
    });

export const getWaitingMemberModelsArray = members =>
    members.map(member => {
        const waitingMemberModel = new WaitingMemberModel(member);
        return { ...waitingMemberModel.waitingMember };
    });

export const getDayWeekWorkoutModelsArray = workouts =>
    workouts.map(workout => {
        const dayWeekWorkoutModel = new DayWeekWorkoutModel(workout);
        return { ...dayWeekWorkoutModel.workout };
    });



// WEBPACK FOOTER //
// ./src/Store/Reducers/helpers.js